import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { isWeekend } from 'date-fns';

export const CustomDay = (props: PickersDayProps<Date>) => {
  const { day, outsideCurrentMonth, ...other } = props;

  const isWeekendDay = isWeekend(day);

  return (
    <PickersDay
      {...other}
      day={day}
      outsideCurrentMonth={outsideCurrentMonth}
      sx={{
        ...(isWeekendDay && {
          backgroundColor: '#ffeeee',
          color: '#d32f2f',
          '&:hover': {
            backgroundColor: '#ffcccc'
          }
        })
      }}
    />
  );
};
